import { DodajZespolModel } from "./dodajZespolModel";

export class EdytujZespolModel extends DodajZespolModel {
    id: string;
}